<template>
  <div class="mx-auto max-w-3xl space-y-14 pb-4">
    <header>
      <h1 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
        {{ t('about.title') }}
      </h1>
      <p class="mt-4 text-lg leading-relaxed text-gray-600">
        {{ t('about.lead') }}
      </p>
    </header>

    <section class="space-y-4">
      <p class="leading-relaxed text-gray-700">
        {{ t('about.marketplace') }}
      </p>
    </section>

    <section class="grid gap-6 md:grid-cols-2">
      <div class="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <UIcon name="i-heroicons-academic-cap" class="mb-3 h-8 w-8 text-primary-500" />
        <h2 class="text-lg font-semibold text-gray-900">
          {{ t('about.venture_title') }}
        </h2>
        <p class="mt-2 text-gray-700">
          {{ t('about.venture') }}
        </p>
      </div>
      <div class="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <UIcon name="i-heroicons-user-group" class="mb-3 h-8 w-8 text-primary-500" />
        <h2 class="text-lg font-semibold text-gray-900">
          {{ t('about.team_title') }}
        </h2>
        <p class="mt-2 text-gray-700">
          {{ t('about.team') }}
        </p>
      </div>
    </section>

    <section class="space-y-4">
      <h2 class="text-xl font-bold text-gray-900">
        {{ t('about.company_heading') }}
      </h2>
      <CompanyDetails />
    </section>

    <section>
      <h2 class="text-xl font-bold text-gray-900">
        {{ t('about.directors_heading') }}
      </h2>
      <ul class="mt-4 space-y-3 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
        <li
          v-for="key in directorKeys"
          :key="key"
          class="border-b border-gray-50 pb-3 text-gray-800 last:border-0 last:pb-0"
        >
          {{ t(`about.directors.${key}`) }}
        </li>
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()

const directorKeys = ['takahashi', 'walston', 'molina', 'ana'] as const

useHead(() => ({
  title: t('about.meta_title'),
  meta: [{ name: 'description', content: t('about.lead') }],
}))
</script>
